import ButtonComponent from "../button";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "./oauthConfig";
import { useNavigate } from "react-router-dom";
import { GetAvailableRoutesByRole } from "../../services/apiService";
import { useDispatch } from "react-redux";
import { setAllowedRoutes } from "../../redux/slices/userSlice";

/*
const GetAvailableRoutes = async (role) => {
  try {
    const response = await GetAvailableRoutesByRole(role);
    console.log("response", response);
    const routes = response.data;
    localStorage.setItem("allowedRoutes", JSON.stringify(routes));
    return routes;
  } catch (error) {
    console.error("Error fetching available routes:", error);
    return [];
  }
};
*/

const ActiveDirectoryIntegrationButton = () => {
  const navigate = useNavigate();
  const { instance } = useMsal();
  const dispatch = useDispatch();

  const handleLogin = async () => {
    try {
      const response = await instance.loginPopup(loginRequest);
      const idTokenClaims = response.idTokenClaims;
      console.log('idTokenClaims',idTokenClaims);
      const role = idTokenClaims?.roles?.[0];
      const userData ={
        name: idTokenClaims.name,
        email: idTokenClaims.preferred_username
      };
      ////const routes = await GetAvailableRoutes(role);
      const responseRoles = await GetAvailableRoutesByRole(role);
      const routes = responseRoles.data;

      // Store allowed routes in Redux
      localStorage.setItem("allowedRoutes", JSON.stringify(routes));
      localStorage.setItem("userData", JSON.stringify(userData));
      dispatch(setAllowedRoutes(routes));

      console.log("routes", routes);
      if (routes.length > 0) {
        console.log("routes.length > 0");
        navigate(routes[0]);
      } else {
        console.log("routes.length else");
        navigate("/Login");
      }
    } catch (error) {
      alert(error);
      console.error(error);
    }
  };

  return (
    <ButtonComponent onClick={handleLogin}>
      Iniciar sesión con Microsoft
    </ButtonComponent>
  );
};

export default ActiveDirectoryIntegrationButton;
